import React, { useEffect } from "react";
import "./AboutWhy.css"; // reuse same CSS

function AboutWhy() {
  useEffect(() => {
    const items = document.querySelectorAll(".choose-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="choose-section">
      <h2 className="choose-title">Why Choose Us</h2>
      <p className="choose-sub">
        We deliver transparent, expert-driven, and customer-focused insurance solutions.
      </p>

      <div className="choose-container">
        {/* LEFT SIDE */}
        <div className="choose-points">
          <div className="choose-item">
            <h3 className="choose-item-title">Transparency & Trust</h3>
            <p className="choose-item-text">
              We explain coverage options in simple, clear terms — no confusing jargon,
              no hidden surprises, just complete transparency.
            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">Expert Guidance</h3>
            <p className="choose-item-text">
              Our experienced team has deep knowledge across life, health, and general
              insurance, helping you make confident, informed decisions.
            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">Personalized Advice & Support</h3>
            <p className="choose-item-text">
         we understanding your personal goals and situation. They offer customized guidance rather than generic suggestions, helping you choose the right coverage based on your needs, budget, and risk profile
            </p>
          </div>
        </div>

        {/* CENTER IMAGE */}
        <div className="choose-image">
          <img src="/menn.png" alt="Insurance Advisory" />
        </div>

        {/* RIGHT SIDE */}
        <div className="choose-points">
          <div className="choose-item">
            <h3 className="choose-item-title">Multiple Insurance Options</h3>
            <p className="choose-item-text">
              As an IMF, we work with multiple insurers, giving you access to a wide
              range of life, health, and general insurance plans in one place.
            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">24/7 Customer Support</h3>
            <p className="choose-item-text">
     Clients expect instant help — not just during business hours. 24/7 support means assistance is available day or night, every day of the year, giving customers peace of mind that their questions or issues will be resolved promptly no matter the time.
            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">Customized Solutions</h3>
            <p className="choose-item-text">
              We don’t believe in one-size-fits-all. Every insurance solution is tailored
              specifically to your needs, lifestyle, and long-term goals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutWhy;
